export type ClassroomCsvRow = { name: string; teacher?: string; students?: number | null };
export type ClassroomCsvResult = { rows: ClassroomCsvRow[]; skipped: number; errors: string[]; total: number };
export const CLASSROOM_CSV_TEMPLATE = 'name,teacher,students\nMath Grade 5,teacher@example.com,25\nReading Grade 6,teacher@example.com,20\n';

export function parseClassroomCreateCsv(text: string): ClassroomCsvResult {
  const records: string[][] = [];
  let row: string[] = [], value = '', quoted = false;
  const input = text.replace(/^\uFEFF/, '');
  for (let i = 0; i < input.length; i++) {
    const char = input[i]!;
    if (char === '"') {
      if (quoted && input[i + 1] === '"') { value += '"'; i++; }
      else quoted = !quoted;
    } else if (char === ',' && !quoted) { row.push(value.trim()); value = ''; }
    else if ((char === '\n' || char === '\r') && !quoted) {
      if (char === '\r' && input[i + 1] === '\n') i++;
      row.push(value.trim()); records.push(row); row = []; value = '';
    } else value += char;
  }
  if (value || row.length) { row.push(value.trim()); records.push(row); }
  if (quoted) return { rows: [], skipped: 0, total: 0, errors: ['CSV contains an unterminated quoted field'] };
  if (!records.some((record) => record.some(Boolean))) return { rows: [], skipped: 0, total: 0, errors: ['CSV is empty'] };
  const header = records[0]?.map((field) => field.toLowerCase()) ?? [];
  const hasHeader = header[0] === 'name';
  if (hasHeader) records.shift();
  const errors: string[] = [];
  if (hasHeader && (header.length > 3 || header.some((field) => !['name', 'teacher', 'students'].includes(field)) || new Set(header).size !== header.length)) errors.push('Header columns must be name, teacher, students');
  const rows: ClassroomCsvRow[] = [];
  let skipped = 0;
  records.forEach((record, index) => {
    const read = (field: string, position: number) => record[hasHeader ? header.indexOf(field) : position] ?? '';
    const name = read('name', 0).trim();
    if (!name) { skipped++; return; }
    if (record.length > 3) { errors.push(`Row ${index + (hasHeader ? 2 : 1)} has too many columns`); return; }
    const rawCount = read('students', 2);
    const count = Number(rawCount);
    const students = Number.isSafeInteger(count) && count >= 0 && count <= 2147483647 ? count : 0;
    rows.push({ name, teacher: read('teacher', 1).trim() || undefined, students });
  });
  if (rows.length > 100) errors.push("Import accepts at most 100 named classroom rows");
  return { rows, skipped, errors, total: records.length };
}
